<router-outlet />
<app-toaster />
<app-open-in-app-banner />
